"use strict";

var _interopRequireWildcard = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var $wl = _interopRequireWildcard(require("@/utils/wl-utils"));
function _default(el /* , binding, vnode, oldVnode */) {
  if (el.getAttribute('dialog-tool-drag') !== null) return;
  if (el.className.indexOf('el-dialog__wrapper') === -1) return;
  var a = el.querySelector('.el-dialog');
  var b = el.querySelector('.el-dialog__header');

  // 给予对话框头部一个可拖拽图标
  b.style.cursor = 'move';

  // Object.assign(a.style, { width: a.clientWidth, height: a.clientHeight })
  // console.log(a.clientWidth, a.clientHeight)

  /* 对话框头部鼠标按下事件 */
  b.onmousedown = function (e0) {
    /* 设置对话框的绝对定位 */
    var top = a.offsetTop + 'px';
    var left = a.offsetLeft + 'px';

    // console.log($wl)
    Object.assign(a.style, {
      position: 'absolute',
      top: top,
      left: left,
      height: $wl.getDomSize(a, 'height') + 'px'
    });

    /* 获取鼠标当前位置（鼠标相对页面可视区域位置） */
    var x0 = e0.clientX;
    var y0 = e0.clientY;

    /* 获取浏览器可视区域尺寸 */
    var d0 = {
      w: document.body.offsetWidth,
      h: document.body.offsetHeight
    };

    /* 获取鼠标当前位置，距离当前元素的边界距离 */
    var p1 = {
      l: a.offsetLeft,
      t: a.offsetTop
    };

    /* 获取对话框尺寸 */
    var d1 = {
      w: a.offsetWidth,
      h: a.offsetHeight
    };

    /* 鼠标移动事件 */
    el.onmousemove = function (e1) {
      /* 获取鼠标当前 X轴 位置 */
      var x1 = e1.clientX;
      var y1 = e1.clientY;
      /* 计算鼠标当前位置与刚按下的时候位置偏移量 */
      var x = x1 - x0;
      var y = y1 - y0;

      /* 计算对话框需要偏移位置 */
      var s1 = {
        l: x + p1.l,
        t: y + p1.t
      };

      /* 对话框实际偏移位置 */
      var s2 = {};

      /* X轴界限控制 */
      /* 如果对话框需要偏移位置 小于零，也就是要超出可视区域左侧，则让实际偏移定为零 */
      if (s1.l < 0) s2.l = 0;
      /* 如果对话框需要偏移位置 大于 页面可视区域，也就是要超出可视区域右侧，则让实际偏移定为 页面可视区域 - 对话框宽度 */else if (s1.l + d1.w > d0.w) s2.l = d0.w - d1.w;
      /* 如果对话框完全在可视区域内，则直接给出计算值 */else s2.l = s1.l;

      /* Y轴界限控制，参考X轴 */
      if (s1.t < 0) s2.t = 0;else if (s1.t + d1.h > d0.h) s2.t = d0.h - d1.h;else s2.t = s1.t;
      Object.assign(a.style, {
        top: s2.t + 'px',
        left: s2.l + 'px'
      });
    };
    var cancel = function cancel() {
      el.onmousemove = null;
      el.onmouseup = null;
      el.onmouseleave = null;
    };
    /* 鼠标抬起事件 */
    el.onmouseup = cancel;
    el.onmouseleave = cancel;
  };
  el.setAttribute('dialog-tool-drag', '');
}